module.exports = __webpack_public_path__ + "img/vegas1.dddc20d5.webp";